import { Invoice } from '../models/shared/Invoice';
import { useText } from '../context/TextContext';

interface Props {
    invoice?: Invoice | null
}
export default function InvoiceState({ invoice }: Props) {
    const text = useText();

    let status = text.invoiceStatusDraft;
    if (invoice) {
        switch (invoice.status) {
            case 'sent':
                status = text.invoiceStatusSent;
                break;
            case 'paid':
                status = text.invoiceStatusPaid;
                break;
            case 'cancelled':
                status = text.invoiceStatusCancelled;
                break;
            default:
                status = text.invoiceStatusDraft;
        }
    }

    return <span className={invoice?.status === 'paid' ? 'text-success' : ''}>({status})</span>
}
